import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '/',
      redirect: 'home',
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/view/login/index'),
      meta: {
        title: '健康中心',
      },
    },
    {
      path: '/home',
      name: 'Home',
      component: () => import('@/view/home/index'),
      meta: {
        title: '健康中心',
      },
    },
    {
      path: '/project',
      name: 'Project',
      component: () => import('@/components/empty'),
      children:
        [
          {
            path: 'card',
            name: 'Card',
            component: () => import('@/components/empty'),
            meta: {
              title: '会员卡',
            },
            children: [
              {
                path: 'listcard',
                name: 'ListCard',
                component: () => import('@/view/project/card/listcard/index'),
                meta: {
                  title: '会员卡',
                },
              },
              {
                path: 'carddetail',
                name: 'CardDetail',
                component: () => import('@/view/project/card/carddetail/index'),
                meta: {
                  title: '会员卡',
                },
              }
            ]
          }
        ]
    },
    {
      path: '/asset',
      name: 'Asset',
      component: () => import('@/components/empty'),
      children:
        [
          {
            path: 'mycard',
            name: 'MyCard',
            component: () => import('@/view/asset/mycard/index'),
            meta: {
              title: '我的会员卡',
            },
          },
          {
            path: 'mycoupon',
            name: 'MyCoupon',
            component: () => import('@/view/asset/mycoupon/index'),
            meta: {
              title: '我的优惠券',
            },
          }
        ]
    },
    {
      path: '/consume',
      name: 'Consume',
      component: () => import('@/components/empty'),
      children:
        [
          {
            path: 'listconsumeorder',
            name: 'ListConsumeOrder',
            component: () => import('@/view/consume/listconsumeorder/index'),
            meta: {
              title: '消费订单',
            },
          },
          {
            path: 'consumeorderdetail',
            name: 'ConsumeOrderDetail',
            component: () => import('@/view/consume/consumeorderdetail/index'),
            meta: {
              title: '订单详情',
            },
          },
          {
            path: 'comment',
            name: 'Comment',
            component: () => import('@/view/consume/comment/index'),
            meta: {
              title: '订单评价',
            },
          },
          {
            path: 'commentorder',
            name: 'CommentOrder',
            component: () => import('@/view/consume/comment/order'),
            meta: {
              title: '评价订单',
            },
          },
        ]
    },
    {
      path: '/recharge',
      name: 'Recharge',
      component: () => import('@/components/empty'),
      children:
        [
          {
            path: 'listrechargeorder',
            name: 'ListRechargeOrder',
            component: () => import('@/view/recharge/listrechargeorder/index'),
            meta: {
              title: '充值订单',
            },
          },
          {
            path: 'rechargeorderdetail',
            name: 'RechargeOrderDetail',
            component: () => import('@/view/recharge/rechargeorderdetail/index'),
            meta: {
              title: '订单详情',
            },
          },
          
          {
            path: 'createrecharge',
            name: 'CreateRecharge',
            component: () => import('@/view/recharge/createrecharge/index'),
            meta: {
              title: '创建充值订单',
            },
          },
          {
            path: 'confirmrecharge',
            name: 'ConfirmRecharge',
            component: () => import('@/view/recharge/confirmrecharge/index'),
            meta: {
              title: '订单详情',
            },
          },
        ]
    },
    {
      path: '/usercenter',
      name: 'UserCenter',
      component: () => import('@/components/empty'),
      children:
        [
          {
            path: 'userinfo',
            name: 'UserInfo',
            component: () => import('@/view/usercenter/userinfo/index'),
            meta: {
              title: '用户信息',
            },
          },
          {
            path: 'perference',
            name: 'Perference',
            component: () => import('@/view/usercenter/perference/index'),
            meta: {
              title: '偏好设置',
            },
          },
          {
            path: 'edituserinfo',
            name: 'EditUserInfo',
            component: () => import('@/view/usercenter/userinfo/edit'),
            meta: {
              title: '编辑信息',
            },
          },
          {
            path: 'address',
            name: 'Address',
            component: () => import('@/components/empty'),
            meta: {
              title: '我的地址',
            },
            children: [
              {
                path: 'listaddress',
                name: 'ListAddress',
                component: () => import('@/view/usercenter/address/listaddress/index'),
                meta: {
                  title: '我的地址',
                },
              },
              {
                path: 'addaddress',
                name: 'AddAddress',
                component: () => import('@/view/usercenter/address/addaddress/index'),
                meta: {
                  title: '新增地址',
                },
              },
              {
                path: 'editaddress',
                name: 'EditAddress',
                component: () => import('@/view/usercenter/address/editaddress/index'),
                meta: {
                  title: '编辑地址',
                },
              }
            ]
          },
          {
            path: 'registeragree',
            name: 'RegisterAgree',
            component: () => import('@/view/usercenter/registeragree/index'),
            meta: {
              title: '注册协议',
            },
          },
          {
            path: 'memberagree',
            name: 'MemberAgree',
            component: () => import('@/view/usercenter/memberagree/index'),
            meta: {
              title: '会员协议',
            },
          },
        ]
    },
    {
      path: '/skin',
      name: 'Skin',
      component: () => import('@/components/empty'),
      children:
        [
          {
            path: 'skin',
            name: 'SkinHome',
            component: () => import('@/view/skin/skin/index'),
            meta: {
              title: '皮肤检测',
            },
          },
          {
            path: 'share',
            name: 'SkinShare',
            component: () => import('@/view/skin/skin/share'),
            meta: {
              title: '皮肤检测',
            },
          },
          {
            path: 'skin1',
            name: 'SkinHome1',
            component: () => import('@/view/skin/skin/index1'),
            meta: {
              title: '皮肤护理建议',
            },
          },
          {
            path: 'history',
            name: 'History',
            component: () => import('@/view/skin/history/index'),
            meta: {
              title: '历史检测',
            },
          },
          {
            path: 'trend',
            name: 'Trend',
            component: () => import('@/view/skin/trend/index'),
            meta: {
              title: '历史趋势',
            },
          },
        ]
    },
    {
      path: '/healthscreen',
      name: 'HealthScreen',
      component: () => import('@/components/empty'),
      children:
        [
          {
            path: 'healthscreenstart',
            name: 'HealthScreenStart',
            component: () => import('@/view/healthscreen/start/index'),
            meta: {
              title: '健康风险排查',
            },
          },
          {
            path: 'healthscreenreport',
            name: 'HealthScreenReport',
            component: () => import('@/view/healthscreen/report/index'),
            meta: {
              title: '健康风险排查',
            },
          },
          {
            path: 'healthscreenreportdetail',
            name: 'HealthScreenReportDetail',
            component: () => import('@/view/healthscreen/reportdetail/index'),
            meta: {
              title: '健康风险排查',
            },
          },
          {
            path: 'healthscreenuserinfo',
            name: 'HealthScreenUserInfo',
            component: () => import('@/view/healthscreen/userinfo/index'),
            meta: {
              title: '健康风险排查',
            },
          },
          {
            path: 'healthscreenask',
            name: 'HealthScreenAsk',
            component: () => import('@/view/healthscreen/ask/index'),
            meta: {
              title: '健康风险排查',
            },
          },
        ]
    },
    {
      path: '/eating',
      name: 'Eating',
      component: () => import('@/components/empty'),
      children:
        [
          {
            path: 'eatingstart',
            name: 'EatingStart',
            component: () => import('@/view/eating/start/index'),
            meta: {
              title: '怎样吃才更健康',
            },
          },
          {
            path: 'eatinguserinfo',
            name: 'EatingUserInfo',
            component: () => import('@/view/eating/userinfo/index'),
            meta: {
              title: '怎样吃才更健康',
            },
          },
          {
            path: 'eatingreport',
            name: 'EatingReport',
            component: () => import('@/view/eating/report/index'),
            meta: {
              title: '怎样吃才更健康',
            },
          },
          {
            path: 'eatingask',
            name: 'EatingAsk',
            component: () => import('@/view/eating/ask/index'),
            meta: {
              title: '怎样吃才更健康',
            },
          },
        ]
    },
    {
      path: '/diet',
      name: 'Diet',
      component: () => import('@/components/empty'),
      children:
        [
          {
            path: 'dietstart',
            name: 'DietStart',
            component: () => import('@/view/diet/start/index'),
            meta: {
              title: '减肥饮食选择',
            },
          },
          {
            path: 'dietask',
            name: 'DietAsk',
            component: () => import('@/view/diet/ask/index'),
            meta: {
              title: '减肥饮食选择',
            },
          },
          {
            path: 'dietreport',
            name: 'DietReport',
            component: () => import('@/view/diet/report/index'),
            meta: {
              title: '减肥饮食选择',
            },
          },
        ]
    },
    {
      path: '/anxiety',
      name: 'Anxiety',
      component: () => import('@/components/empty'),
      children:
        [
          {
            path: 'anxietystart',
            name: 'AnxietyStart',
            component: () => import('@/view/anxiety/start/index'),
            meta: {
              title: '焦虑测评',
            },
          },
          {
            path: 'anxietyask',
            name: 'AnxietyAsk',
            component: () => import('@/view/anxiety/ask/index'),
            meta: {
              title: '焦虑测评',
            },
          },
          {
            path: 'anxietyreport',
            name: 'AnxietyReport',
            component: () => import('@/view/anxiety/report/index'),
            meta: {
              title: '焦虑测评',
            },
          },
        ]
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js